<div class="page-head">
  <div>
    <h1>Roles</h1>
    <div class="sub">Manage roles and permissions across the Plus platform</div>
  </div>
</div>

<div class="page-body" *ngIf="!isLoading; else loadingTpl">
  <div class="split">
    <div class="list-pane">
      <input
        class="inp"
        type="text"
        placeholder="Search roles…"
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearch($event)"
      />

      <div class="segmented" role="group" aria-label="Filter role type">
        <button type="button" [class.active]="filterMode === 'all'" (click)="setFilterMode('all')">All</button>
        <button type="button" [class.active]="filterMode === 'system'" (click)="setFilterMode('system')">System</button>
        <button type="button" [class.active]="filterMode === 'business'" (click)="setFilterMode('business')">Business</button>
      </div>

      <ul class="rows">
        <li
          class="row clickable"
          *ngFor="let role of filteredRoles"
          [class.active]="selectedRole?.roleId === role.roleId"
          (click)="onSelectRole(role)"
        >
          <div class="row-main">
            <div class="row-title">{{ role.displayName || role.roleName }}</div>
            <span class="pill pill-sm">Staff rank {{ role.staffRank ?? '—' }}</span>
          </div>
          <span class="pill pill-sm" [class.pill-grey]="!role.isSystemLevel">
            {{ role.isSystemLevel ? 'System' : 'Business' }}
          </span>
        </li>
        <li class="empty" *ngIf="!filteredRoles?.length">No roles match.</li>
      </ul>
    </div>

    <div class="detail-pane">
      <ng-container *ngIf="selectedRole; else noRoleTpl">
        <app-role-detail
          [role]="selectedRole"
          [allPermissions]="permissions"
          (roleUpdated)="onRoleUpdated($event)"
        ></app-role-detail>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #loadingTpl>
  <div class="loading">Loading roles…</div>
</ng-template>

<ng-template #noRoleTpl>
  <div class="panel empty">Select a role to manage its permissions.</div>
</ng-template>
